export const CATEGORY_ID = {
    PIZZA: "pizza",
    HAMBURGUER: "hamburger",
    HOTDOG: "hot-dog",
    DISH: "dish",
    BARBECUE: "barbecue",
    SUSHI: "sushi",
    ORIENTAL: "oriental",
    PASTEL: "pastel",
    SNACK: "snack",
    TAPIOCA: "tapioca",
    ACAI: "acai",
    ICE_CREAM: "ice-cream",
    SHAWARMA:"shawarma",
    DRINK: "drink"
}

export const CATEGORIES = [
    {
        id: CATEGORY_ID.PIZZA, 
        title: "Pizza"
    }, 
    {
        id: CATEGORY_ID.HAMBURGUER, 
        title: "Hamburguer"
    }, 
    {
        id: CATEGORY_ID.DISH, 
        title: "Refeição"
    }, 
    {
        id: CATEGORY_ID.BARBECUE, 
        title: "Churrasco"
    },
    {
        id: CATEGORY_ID.ORIENTAL, 
        title: "Oriental"
    }, 
    {
        id: CATEGORY_ID.PASTEL, 
        title: "Pastel"
    },
    {
        id: CATEGORY_ID.SNACK, 
        title: "Lanche"
    },
    {
        id: CATEGORY_ID.TAPIOCA, 
        title: "Tapioca"
    }, 
    {
        id: CATEGORY_ID.ACAI, 
        title: "Açaí"
    },
    {
        id: CATEGORY_ID.ICE_CREAM, 
        title: "Sorvete"
    },
    {
        id: CATEGORY_ID.SHAWARMA, 
        title: "Shawarma"
    }, 
    {
        id: CATEGORY_ID.DRINK, 
        title: "Bebidas"
    },
]